import React from 'react';
import { TypographyBody, Toasts, toasts, createToastsStore, TickCircleIcon, ExclamationIcon } from '@honeycomb/ui-core';
import { useNotification, NotificationTypes } from '@honeycomb/data';
const globalToastsStore = createToastsStore();
export function Notification() {
    var _a;
    const [currentNotification, setCurrentNotification] = useNotification();
    const { isOpen, notificationType = NotificationTypes.None, message, heading, subHeading, autoHideDuration = 0, } = ((_a = currentNotification.data) === null || _a === void 0 ? void 0 : _a.currentNotification) || {};
    const isError = notificationType === NotificationTypes.Error;
    const handleClose = React.useCallback(() => setCurrentNotification({ isOpen: false, notificationType }), [notificationType, setCurrentNotification]);
    React.useEffect(() => {
        // Add the toast
        if (isOpen) {
            toasts.show({
                message: !isError ? (React.createElement(React.Fragment, null,
                    React.createElement(TypographyBody, { weight: "bold", "data-id": "notification-heading-message" }, heading),
                    React.createElement("p", { "data-id": "notification-subheading-message" }, subHeading))) : (React.createElement(TypographyBody, { weight: "bold", "data-id": "notification-error-message" }, message)),
                position: 'bottom-center',
                icon: isError ? React.createElement(ExclamationIcon, null) : React.createElement(TickCircleIcon, null),
                color: isError ? 'error' : 'success',
                autoClose: autoHideDuration || undefined,
                onClose: handleClose,
            }, globalToastsStore);
        }
    }, [heading, subHeading, message, isError, autoHideDuration, handleClose, isOpen]);
    return React.createElement(Toasts, { store: globalToastsStore, toastWidth: "fill" });
}
